const Loader = () => {
  return (
    <div className="loader-sec">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
